/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import * as models from "../index.js";

/**
 * An enumeration.
 */
export const ListChainKeyTransactionCountApiV2TransactionCountGetStep = {
  EightySixThousandFourHundred: 86400,
  ThreeThousandSixHundred: 3600,
} as const;
/**
 * An enumeration.
 */
export type ListChainKeyTransactionCountApiV2TransactionCountGetStep =
  ClosedEnum<typeof ListChainKeyTransactionCountApiV2TransactionCountGetStep>;

export type ListChainKeyTransactionCountApiV2TransactionCountGetRequest = {
  start?: number | undefined;
  end?: number | undefined;
  /**
   * An enumeration.
   */
  step?: ListChainKeyTransactionCountApiV2TransactionCountGetStep | undefined;
  /**
   * An enumeration.
   */
  network?: models.Network | undefined;
  /**
   * An enumeration.
   */
  tokenType?: models.AppModelsLedgersTokenType | undefined;
};

/** @internal */
export const ListChainKeyTransactionCountApiV2TransactionCountGetStep$inboundSchema:
  z.ZodNativeEnum<
    typeof ListChainKeyTransactionCountApiV2TransactionCountGetStep
  > = z.nativeEnum(ListChainKeyTransactionCountApiV2TransactionCountGetStep);

/** @internal */
export const ListChainKeyTransactionCountApiV2TransactionCountGetStep$outboundSchema:
  z.ZodNativeEnum<
    typeof ListChainKeyTransactionCountApiV2TransactionCountGetStep
  > = ListChainKeyTransactionCountApiV2TransactionCountGetStep$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListChainKeyTransactionCountApiV2TransactionCountGetStep$ {
  /** @deprecated use `ListChainKeyTransactionCountApiV2TransactionCountGetStep$inboundSchema` instead. */
  export const inboundSchema =
    ListChainKeyTransactionCountApiV2TransactionCountGetStep$inboundSchema;
  /** @deprecated use `ListChainKeyTransactionCountApiV2TransactionCountGetStep$outboundSchema` instead. */
  export const outboundSchema =
    ListChainKeyTransactionCountApiV2TransactionCountGetStep$outboundSchema;
}

/** @internal */
export const ListChainKeyTransactionCountApiV2TransactionCountGetRequest$inboundSchema:
  z.ZodType<
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step: ListChainKeyTransactionCountApiV2TransactionCountGetStep$inboundSchema
      .default(86400),
    network: models.Network$inboundSchema.optional(),
    token_type: models.AppModelsLedgersTokenType$inboundSchema.optional(),
  }).transform((v) => {
    return remap$(v, {
      "token_type": "tokenType",
    });
  });

/** @internal */
export type ListChainKeyTransactionCountApiV2TransactionCountGetRequest$Outbound =
  {
    start?: number | undefined;
    end?: number | undefined;
    step: number;
    network?: string | undefined;
    token_type?: string | undefined;
  };

/** @internal */
export const ListChainKeyTransactionCountApiV2TransactionCountGetRequest$outboundSchema:
  z.ZodType<
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest$Outbound,
    z.ZodTypeDef,
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest
  > = z.object({
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step:
      ListChainKeyTransactionCountApiV2TransactionCountGetStep$outboundSchema
        .default(86400),
    network: models.Network$outboundSchema.optional(),
    tokenType: models.AppModelsLedgersTokenType$outboundSchema.optional(),
  }).transform((v) => {
    return remap$(v, {
      tokenType: "token_type",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListChainKeyTransactionCountApiV2TransactionCountGetRequest$ {
  /** @deprecated use `ListChainKeyTransactionCountApiV2TransactionCountGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest$inboundSchema;
  /** @deprecated use `ListChainKeyTransactionCountApiV2TransactionCountGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest$outboundSchema;
  /** @deprecated use `ListChainKeyTransactionCountApiV2TransactionCountGetRequest$Outbound` instead. */
  export type Outbound =
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest$Outbound;
}

export function listChainKeyTransactionCountApiV2TransactionCountGetRequestToJSON(
  listChainKeyTransactionCountApiV2TransactionCountGetRequest:
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest,
): string {
  return JSON.stringify(
    ListChainKeyTransactionCountApiV2TransactionCountGetRequest$outboundSchema
      .parse(listChainKeyTransactionCountApiV2TransactionCountGetRequest),
  );
}

export function listChainKeyTransactionCountApiV2TransactionCountGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListChainKeyTransactionCountApiV2TransactionCountGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListChainKeyTransactionCountApiV2TransactionCountGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListChainKeyTransactionCountApiV2TransactionCountGetRequest' from JSON`,
  );
}
